import React from 'react';
import { Link  } from 'react-router-dom';
import posed from 'react-pose';

const BoxTitle = posed.div({
  visible: { 
    x: 0,
    opacity: 1,
    transition: { duration: 600 }
  },
  exit: {
    x: 50,
    opacity: 0,
    transition: { duration: 600 }
  }
});
const BoxSubTitle = posed.div({
  visible: { 
    x: 0,
    opacity: 1,
    transition: { duration: 600 }
  },
  exit: {
    x: -50,
    opacity: 0,
    transition: { duration: 600 }
  }
});
const BoxLogo = posed.div({
  visible: { 
    scale: 1,
    opacity: 1,
    transition: { duration: 600 }
  },
  exit: {
    scale: 0,
    opacity: 0,
    transition: { duration: 600 }
  }
});
const BoxFildsTitle = posed.div({
  visible: { 
    y: 0,
    opacity: 1,
    transition: { duration: 600 }
  },
  exit: {
    y: -50,
    opacity: 0,
    transition: { duration: 600 }
  }
});
const BoxFilds = posed.div({
  visible: { 
    x: 0,
    opacity: 1,
    transition: { duration: 600 }
  },
  exit: {
    x: 50,
    opacity: 0,
    transition: { duration: 600 }
  }
});

class WorkDetailsHeader extends React.Component{

  state = {
    isVisible:false,
    isImgVisible:false
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filds.length !== 0) {
      this.setState({ isVisible: true });
    }
  }

  handelLogoLoad = () =>{
    this.setState({ isImgVisible: true });
  }
    
  render(){
    return(
      <div>
        <header className="WorkDetailsHeader">
          <div className="bContainer v-bottom">
          <div className="col-xs-6 col-sm-4 col-md-5">
            <div className="title">
            <BoxSubTitle className="head"
            pose={this.state.isVisible ? 'visible' : 'hidden'}
            >
                <p>Work and projects</p>
            </BoxSubTitle>
              <BoxTitle className="head"
              pose={this.state.isVisible ? 'visible' : 'hidden'}
              >
                <h1 dangerouslySetInnerHTML={{__html: this.props.name}}/>
              </BoxTitle>
            </div>
          </div>
          <div className="col-sm-4 col-md-2 hidden-xs">
            <div className="logo">
              <BoxLogo className="head"
                pose={this.state.isImgVisible ? 'visible' : 'hidden'}
              >
                <img onLoad={this.handelLogoLoad} className="center-block" src={this.props.logoUrl} />
              </BoxLogo>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-5">
            <div className="filtersBox">
              <BoxFildsTitle className="head"
                pose={this.state.isVisible ? 'visible' : 'hidden'}
              />
              <div className="filtersBody">
                <BoxFilds
                  className="box"
                  pose={this.state.isVisible ? 'visible' : 'hidden'}
                >
                  
                  <p>{this.props.filds[0] && 'Web development'}</p>
                  <p>{this.props.filds[1] && 'Web design'}</p>
                  <p>{this.props.filds[2] && 'Mobile application'}</p>
                  <p>{this.props.filds[3] && 'Corporate identity'}</p>
                </BoxFilds>
              </div>
            </div>
          </div>
          </div>
        </header>
      </div>
      
    );
  }
}


export default WorkDetailsHeader;



// WEBPACK FOOTER //
// ./src/components/WorkDetailsHeader.js